import { Link } from 'react-router-dom';
import usePageMeta from '../components/usePageMeta';

function About() {
  usePageMeta(
    'About',
    'Australia College builds practical software for classrooms, focused on giving educators and students their time back.'
  );

  return (
    <>
      <section className="product-hero">
        <div className="container">
          <span className="eyebrow">About us</span>
          <h1>Software built with the classroom in mind</h1>
          <p className="product-hero-lead">
            Australia College is a software company focused on education.
            We build tools for teachers, students and families that are
            designed to be genuinely useful day to day — not just
            impressive in a demo.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="grid grid-2" style={{ alignItems: 'start' }}>
            <div>
              <h2>Our mission</h2>
              <p>
                Educators and students lose a huge amount of time to
                repetitive admin, resource creation and coordination work
                that pulls focus away from actual teaching and learning. Our
                mission is to chip away at that, one focused product at a
                time.
              </p>
              <p>
                We'd rather ship a small number of tools that do their job
                well than a large number of tools that do a lot of things
                poorly. Each product we build starts from a specific,
                real problem educators or families told us about.
              </p>
            </div>
            <div>
              <h2>How we work</h2>
              <ul className="feature-list">
                <li>
                  <span className="feature-tick">✓</span>
                  <span>
                    <strong>Practical over flashy.</strong> We prioritise
                    tools that save real time over ones that just look good
                    in a screenshot.
                  </span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>
                    <strong>Built with educator input.</strong> Product
                    decisions are shaped by feedback from the people who
                    actually use the software.
                  </span>
                </li>
                <li>
                  <span className="feature-tick">✓</span>
                  <span>
                    <strong>Simple by default.</strong> We keep our products
                    focused, and we're careful about what data we collect
                    and why.
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      <section className="section section--alt">
        <div className="container">
          <div className="section-head center">
            <span className="eyebrow">What we're building</span>
            <h2>A small, growing family of education products</h2>
            <p>
              From desktop productivity tools for teachers to web platforms
              for resource creation and student tutoring, each Australia
              College product targets a specific part of the education
              workflow.
            </p>
          </div>
          <div style={{ textAlign: 'center' }}>
            <Link to="/products" className="btn btn-primary">
              See our products
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="cta-banner">
            <div>
              <h2 style={{ marginBottom: 8 }}>Want to know more?</h2>
              <p>We're happy to answer questions about any of our products.</p>
            </div>
            <div className="cta-banner-actions">
              <Link to="/contact" className="btn btn-amber">
                Contact us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default About;
